/** English strings — the source of truth for translation keys. */
export const en = {
  'app.name': 'Card Hub',
  'app.tagline': 'Call Break · Teen Patti · Poker · Marriage',
  'common.continue': 'Continue',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.retry': 'Try again',
  'common.loading': 'Loading…',
  'common.done': 'Done',
  'common.skip': 'Skip',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.coins': 'coins',
  'common.online': '{n} online',
  'common.copy': 'Copy',
  'common.copied': 'Copied!',
  'common.share': 'Share',
  'common.level': 'Lv {n}',
  'common.free': 'Free',
  'common.claim': 'Claim',
  'common.claimed': 'Claimed',
  'common.seeAll': 'See all',
  'common.comingSoon': 'Coming soon',
  'common.bot': 'BOT',
  'error.generic': 'Something went wrong. Please try again.',
  'error.network': "Can't reach the server. Check your connection.",
  'error.offline': "You're offline. We'll reconnect automatically.",
  'error.reconnecting': "Connection lost. We're trying to reconnect you…",
  'error.maintenance': "We're doing a quick upgrade. Please try again in a few minutes.",
  'error.sessionExpired': 'Your session ended. Please sign in again.',
  'nav.home': 'Home',
  'nav.play': 'Play',
  'nav.friends': 'Friends',
  'nav.ranks': 'Ranks',
  'nav.profile': 'Profile',
  'onboard.welcome.title': 'Card nights, anytime.',
  'onboard.welcome.body': 'Play your favourite card games with friends and players nearby. Free coins, no real money.',
  'onboard.welcome.cta': 'Get started',
  'onboard.welcome.login': 'I already have an account',
  'onboard.username.title': 'Pick a player name',
  'onboard.username.hint': '3–20 letters, numbers or _',
  'onboard.avatar.title': 'Choose your avatar',
  'onboard.signup.title': 'Secure your account',
  'onboard.signup.body': 'Set a password so you can sign in on any device. Email is optional and helps you recover your account.',
  'onboard.bonus.title': 'Welcome gift!',
  'onboard.bonus.body': '{amount} coins have been added to your wallet.',
  'onboard.bonus.pending': 'Your welcome bonus is being reviewed and will arrive shortly.',
  'onboard.favorite.title': 'What do you like to play?',
  'onboard.tutorial.title': 'Quick tutorial?',
  'onboard.tutorial.body': 'Learn the basics in under a minute, or jump straight in.',
  'onboard.tutorial.yes': 'Show me how',
  'onboard.tutorial.no': 'Play now',
  'auth.login': 'Sign in',
  'auth.guest': 'Continue as Guest',
  'onboard.welcome.games': '{n} card games',
  'onboard.welcome.perkCoins': 'Free coins',
  'onboard.welcome.perkBots': 'Practice vs bots',
  'auth.register': 'Create account',
  'auth.username': 'Username',
  'auth.identifier': 'Username or email',
  'auth.password': 'Password',
  'auth.email': 'Email (optional)',
  'auth.referral': 'Referral code (optional)',
  'auth.phone': 'Phone number',
  'auth.sendCode': 'Send code',
  'auth.code': '6-digit code',
  'auth.verify': 'Verify',
  'auth.usePhone': 'Use phone number',
  'auth.usePassword': 'Use username & password',
  'auth.logout': 'Sign out',
  'auth.noAccount': 'New here? Create an account',
  'lobby.quickPlay': 'Quick Play',
  'lobby.privateRoom': 'Private room',
  'lobby.daily': 'Daily',
  'lobby.missions': 'Missions',
  'lobby.store': 'Store',
  'lobby.watchAd': 'Free coins',
  'lobby.games': 'Games',
  'lobby.recent': 'Recent games',
  'games.search': 'Search games',
  'games.clear': 'Clear search',
  'games.noMatch': 'No games match "{q}"',
  'games.results': '{n} games found',
  'games.favourites': 'Favourites',
  'games.recentlyPlayed': 'Recently played',
  'games.all': 'All games',
  'games.favAdd': 'Add {game} to favourites',
  'games.favRemove': 'Remove {game} from favourites',
  'lobby.events': 'Events',
  'lobby.tournaments': 'Tournaments',
  'lobby.tables': '{n} tables',
  'lobby.entry': 'Entry {min}–{max}',
  'lobby.continueGame': 'You have a game in progress',
  'lobby.rejoin': 'Rejoin',
  'lobby.joinRoom': 'Join with code',
  'lobby.howToPlay': 'How to play',
  'game.CALL_BREAK': 'Call Break',
  'game.SPADES': 'Spades',
  'game.TARNEEB': 'Tarneeb',
  'game.HEARTS': 'Hearts',
  'game.FIVE_HUNDRED': 'Five Hundred',
  'game.JUDGEMENT': 'Judgement',
  'game.RUMMY': 'Rummy',
  'game.EUCHRE': 'Euchre',
  'game.GIN_RUMMY': 'Gin Rummy',
  'game.TWENTY_NINE': 'Twenty-Nine',
  'game.CRAZY_EIGHTS': 'Crazy Eights',
  'game.CRIBBAGE': 'Cribbage',
  'game.BLACKJACK': 'Blackjack',
  'game.BHABHI': 'Bhabhi',
  'game.PINOCHLE': 'Pinochle',
  'game.ANDAR_BAHAR': 'Andar Bahar',
  'game.BRIDGE': 'Bridge',
  'game.SEVENS': 'Sevens',
  'game.SCOPA': 'Scopa',
  'game.BACCARAT': 'Baccarat',
  'game.BLUFF': 'Bluff',
  'game.DRAGON_TIGER': 'Dragon Tiger',
  'game.FLUSH': 'Flush',
  'game.COURT_PIECE': 'Court Piece',
  'game.DEHLA_PAKAD': 'Dehla Pakad',
  'dp.firstFive': 'Pick trump from your first five cards',
  'dp.outcome.KOT': 'Kot! One team took all 13 tricks',
  'dp.outcome.MENDICOT': 'Mendicot — one team took all four tens',
  'dp.outcome.TENS': 'Three tens decide the hand',
  'dp.outcome.TRICKS': 'Tens split 2–2 — more tricks wins',
  'dp.scoreHint': 'First to {target} points wins. The four tens are the prize: three tens scores 1, all four (Mendicot) scores 2, a tens split 2–2 goes to the team with more tricks, and taking all 13 tricks (Kot) scores 3.',
  'wh.hand': 'Hand {n}',
  'wh.trump': 'Trump',
  'wh.dealerHolds': '{name} holds the turned-up card',
  'wh.tricks': '{n} tricks',
  'wh.handScores': 'Hand {n} scores',
  'wh.scoreHint': 'First partnership to {target} points wins. Only tricks above six score.',
  'cnt.hand': 'Hand {n}',
  'cnt.stock': 'Stock {n}',
  'cnt.pile': 'Pile ({n})',
  'cnt.frozen': 'Frozen',
  'cnt.draw': 'Draw 2',
  'cnt.take': 'Take pile',
  'cnt.meld': 'Meld',
  'cnt.discard': 'Discard',
  'cnt.clear': 'Clear',
  'cnt.ourMelds': 'Our melds',
  'cnt.theirMelds': 'Their melds',
  'cnt.canasta': 'Canasta',
  'cnt.noMeld': 'none yet',
  'cnt.need': 'First meld needs {n}+ points',
  'cnt.pickRank': 'Add wild cards to which meld?',
  'cnt.wildNeedRank': 'Select natural cards of one rank together with your wild cards',
  'cnt.wentOut': '{name} went out',
  'cnt.stockOut': 'The stock ran out',
  'cnt.scoreHint': 'First partnership to {target} points wins. Each cell reads melds + canastas + red threes + out bonus − cards left.',
  'r5.hand': 'Hand {n}',
  'r5.stock': 'Stock {n}',
  'r5.pile': 'Discard pile ({n})',
  'r5.tapPile': 'Tap a highlighted card to take it and the cards above',
  'r5.draw': 'Draw',
  'r5.meldBtn': 'Meld',
  'r5.discard': 'Discard',
  'r5.clear': 'Clear',
  'r5.melds': 'Melds on the table',
  'r5.noMelds': 'No melds yet',
  'r5.meld': 'Meld',
  'r5.you': 'You',
  'r5.wentOut': '{name} went out',
  'r5.stockOut': 'The stock ran out',
  'r5.layoffHint': 'Select one card in your hand, then tap the meld',
  'r5.noFit': 'That card does not fit this meld',
  'r5.mustUse': 'Use the {card} you took this turn',
  'r5.scoreHint': 'First to {target} points wins. Melded cards score for you, cards left in hand count against you; each cell reads melded − hand.',
  'be.hand': 'Hand {n}',
  'be.round1': 'Bidding: take the card?',
  'be.round2': 'Bidding: name a trump',
  'be.upCard': 'Turned-up card',
  'be.take': 'Take',
  'be.taker': 'Taker',
  'be.belote': 'Belote',
  'be.capot': 'Capot',
  'be.bid': 'Bid',
  'be.takeUp': 'Take the turned-up suit as trump?',
  'be.nameTrump': 'Name a trump suit, or pass',
  'be.chooseSuit': 'Choose trump suit',
  'be.handScores': 'Hand {n} scores',
  'be.failed': '{name}’s team missed the contract',
  'be.scoreHint': 'First partnership to {target} points wins. The taker needs more points than the defenders; belote-rebelote is 20 and a capot adds 90.',
  'pch.hand': 'Hand {n}',
  'pch.bidN': 'Bid {n}',
  'pch.bidder': 'Bidder',
  'pch.bid': 'Your bid',
  'pch.toBid': 'Bid or pass',
  'pch.stuck': 'Everyone passed: you are stuck with 2',
  'pch.sets': 'First card sets trump',
  'pch.bidsInfo': '{name} bid {n}',
  'pch.handScores': 'Hand {n} scores',
  'pch.setBack': '{name}’s side was set back by {n}',
  'pch.high': 'High',
  'pch.low': 'Low',
  'pch.jack': 'Jack',
  'pch.game': 'Game',
  'pch.scoreHint': 'First partnership to {target} points wins. Win High, Low, Jack and Game: the bidders must reach their bid or lose it.',
  'pch.pitchIt': 'Lead any card: its suit becomes trump',
  'pch.bidWas': 'Bid {n}',
  'bsc.stock': '{n} left',
  'bsc.trumpCard': 'Trump card',
  'bsc.pts': 'pts',
  'bsc.won': 'won',
  'bsc.handWon': 'hand won',
  'bsc.drawn': 'Drawn 60–60 — dealt again',
  'bsc.scoreHint': 'More than 60 of the 120 points wins a hand. First partnership to {target} won hand(s) wins the match.',
  'trs.pts': 'pts',
  'trs.target': 'First to {n}',
  'trs.thisHand': 'this hand',
  'trs.scoreHint': 'Aces are worth 1 point and the 3, 2, K, Q and J a third each; the last trick adds 1. Each hand is rounded down to whole points. First partnership to {target} points wins the match.',
  'game.WHIST': 'Whist',
  'game.SEEP': 'Seep',
  'game.BELOTE': 'Belote',
  'game.DURAK': 'Durak',
  'du.cards': '{n} cards',
  'du.out': 'Out · {n}',
  'du.attacker': 'Attacker',
  'du.defender': 'Defender',
  'du.durakTag': 'Durak',
  'du.bout': 'Bout {n}',
  'du.stock': 'Stock {n}',
  'du.trump': 'Trump',
  'du.trumpCard': 'Trump card',
  'du.defendHint': 'Beat the card with a higher card or a {trump} trump — or take it',
  'du.cannotBeat': 'You cannot beat it — take the cards',
  'du.leadHint': 'Lead any card',
  'du.pileOnHint': 'They are taking — pile on a matching rank or pass',
  'du.throwHint': 'Throw in a matching rank, or pass',
  'du.took': '{name} takes the cards',
  'du.beaten': 'Beaten — {name} attacks next',
  'du.taking': '{name} is taking the cards',
  'du.noDurak': 'Everyone got out — no Durak!',
  'du.isDurak': '{name} is the Durak!',
  'du.take': 'Take cards',
  'du.pass': 'Pass',
  'du.player': 'Player',
  'du.cardsLeft': 'Cards left',
  'du.outShort': 'Out',
  'du.scoreHint': 'Beat every attack with a higher card of the same suit or a trump, or take the cards. Others may throw in cards matching a rank on the table. After each bout everyone refills to six. Once the stock is empty, players with no cards are out — the last player holding cards is the Durak.',
  'game.PRESIDENT': 'President',
  'game.BRISCOLA': 'Briscola',
  'game.CASINO_WAR': 'Casino War',
  'game.THREE_CARD_POKER': 'Three Card Poker',
  'game.GO_FISH': 'Go Fish',
  'game.TRESSETTE': 'Tressette',
  'game.RED_DOG': 'Red Dog',
  'game.CANASTA': 'Canasta',
  'game.SKAT': 'Skat',
  'skt.deal': 'Deal {n}',
  'skt.bid': 'Bid',
  'skt.playing': 'Playing',
  'skt.skat': 'Skat',
  'skt.skatTaken': 'Skat taken',
  'skt.holds': 'Holds',
  'skt.declarer': 'Declarer',
  'skt.cardPts': '{n} pts',
  'skt.bidding': '{name} is bidding',
  'skt.looking': '{name} is looking at the skat',
  'skt.choosing': '{name} is choosing a game',
  'skt.redealt': 'Everyone passed, so the cards were dealt again',
  'skt.handScores': 'Deal {n} result',
  'skt.won': '{name} won',
  'skt.lost': '{name} lost',
  'skt.declarerPoints': '{n} card points',
  'skt.with': 'with {n}',
  'skt.without': 'without {n}',
  'skt.schneider': 'Schneider',
  'skt.schwarz': 'Schwarz',
  'skt.overbid': 'Overbid: the game was worth {value}, less than the bid of {bid}.',
  'skt.bidTitle': 'Your bid',
  'skt.forehandTitle': 'Everyone passed. Play at 18?',
  'skt.current': 'Current bid {n}',
  'skt.more': 'More bids',
  'skt.respondTitle': 'Hold or pass?',
  'skt.hold': 'Hold {n}',
  'skt.youWon': 'You won the bid at {n}',
  'skt.skatHint': 'Pick up the two skat cards, then discard two cards and name your game.',
  'skt.pickup': 'Pick up the skat',
  'skt.declareTitle': 'Discard two cards, then name your game',
  'skt.discardCount': '{n} of 2 selected',
  'skt.chooseGame': 'Game',
  'skt.worth': 'Worth {value} (base {base})',
  'skt.worthLess': 'Worth only {value}, less than your bid of {bid}. You would lose.',
  'skt.confirm': 'Play {game}',
  'skt.game.C': 'Clubs',
  'skt.game.S': 'Spades',
  'skt.game.H': 'Hearts',
  'skt.game.D': 'Diamonds',
  'skt.game.GRAND': 'Grand',
  'skt.game.NULL': 'Null',
  'skt.scoreHint': 'First player to {target} points wins. Only the declarer scores: the game value for a win, minus twice the value for a loss. Hand, Ouvert and Ramsch are not played.',
  'game.PAI_GOW': 'Pai Gow Poker',
  'game.BIG_TWO': 'Big Two',
  'bt.cards': '{n} cards',
  'bt.out': 'Out · {n}',
  'bt.first': '1st',
  'bt.second': '2nd',
  'bt.third': '3rd',
  'bt.last': 'Last',
  'bt.leadHint': 'Your lead — play a single, a pair, three of a kind or a five-card hand',
  'bt.openHint': 'You lead — your first play must include the 3♦',
  'bt.followHint': 'Beat it with {n} higher — or pass',
  'bt.passed': 'Passed',
  'bt.play': 'Play',
  'bt.pass': 'Pass',
  'bt.pile': 'Pile {n}',
  'bt.empty': 'Lead any combination',
  'bt.player': 'Player',
  'bt.cardsLeft': 'Cards left',
  'bt.outShort': 'Out',
  'bt.clearedPasses': 'Everyone passed — {name} leads',
  'bt.isLast': '{name} is last',
  'bt.scoreHint': 'Be first to play every card. Beat the last play with the same number of cards, or pass. Twos are highest; spades beat hearts, clubs and diamonds. Finishing order sets the places.',
  'bt.single': 'Single',
  'bt.pair': 'Pair',
  'bt.triple': 'Three of a kind',
  'bt.straight': 'Straight',
  'bt.flush': 'Flush',
  'bt.fullhouse': 'Full house',
  'bt.four': 'Four of a kind',
  'bt.straightflush': 'Straight flush',
  'bt.selectHint': 'Tap cards to build a play, then press Play',
  'game.WAR': 'War',
  'game.RUMMY_500': 'Rummy 500',
  'game.BRAG': 'Three Card Brag',
  'game.PITCH': 'Pitch',
  'game.HAZARI': 'Hazari',
  'game.TEEN_PATTI': 'Teen Patti',
  'game.POKER': 'Poker',
  'game.MARRIAGE': 'Marriage',
  'tables.title': 'Choose a table',
  'tables.entry': 'Entry',
  'tables.buyIn': 'Buy-in',
  'tables.minBalance': 'Min balance {n}',
  'tables.players': '{min}–{max} players',
  'tables.timer': '{n}s turns',
  'tables.play': 'Play',
  'tables.cantAfford': 'Need {n}',
  'mm.searching': 'Finding players…',
  'mm.waited': 'Searching for {s}s',
  'mm.cancel': 'Cancel',
  'mm.matched': 'Table found!',
  'mm.failed': "We couldn't start that table.",
  'table.leave': 'Leave',
  'table.leaveConfirm': 'Leave this table?',
  'table.leaveMatchWarn': 'The match continues without you and you forfeit your entry.',
  'table.leaveSessionWarn': 'Your remaining chips return to your wallet.',
  'table.yourTurn': 'Your turn',
  'table.waitingFor': 'Waiting for {name}',
  'table.waitingPlayers': 'Waiting for players…',
  'offline.title': "You're offline",
  'offline.body': 'You can still play every game against bots at your usual tables. Your coins, XP and stats are updated once you are back online.',
  'offline.tile': 'Play offline',
  'offline.play': 'Play offline',
  'offline.pending': '{n} offline game(s) will be settled when you are back online.',
  'table.autoPlay': 'Auto-play is on',
  'table.imBack': "I'm back",
  'table.round': 'Round {n}/{total}',
  'table.hand': 'Hand #{n}',
  'table.pot': 'Total pot',
  'install.title': 'Install Card Hub',
  'install.body': 'Play full screen and open it straight from your home screen.',
  'install.button': 'Install',
  'install.later': 'Not now',
  'install.howTo': 'How to install',
  'install.ios': 'Tap the Share button in your browser, then choose “Add to Home Screen”.',
  'install.android': 'Open your browser menu (the three dots), then tap “Install app” or “Add to Home screen”.',
  'table.chat': 'Chat',
  'table.send': 'Send',
  'table.scores': 'Scores',
  'table.away': 'away',
  'cb.bid': 'Call your tricks',
  'cb.bidValue': 'Call {n}',
  'cb.tricks': '{won}/{bid}',
  'cb.suggested': 'Suggested',
  'cb.playCard': 'Play a card',
  'tp.see': 'See cards',
  'tp.chaal': 'Chaal {n}',
  'tp.blind': 'Blind {n}',
  'tp.raise': 'Raise {n}',
  'tp.pack': 'Pack',
  'tp.show': 'Show {n}',
  'tp.sideShow': 'Side show {n}',
  'tp.sideShowAsk': '{name} asks for a side show',
  'tp.accept': 'Accept',
  'tp.decline': 'Decline',
  'tp.stake': 'Stake {n}',
  'tp.blindTag': 'BLIND',
  'tp.seenTag': 'SEEN',
  'tp.packedTag': 'PACKED',
  'pk.fold': 'Fold',
  'pk.check': 'Check',
  'pk.call': 'Call {n}',
  'pk.bet': 'Bet {n}',
  'pk.raiseTo': 'Raise to {n}',
  'pk.allIn': 'All-in',
  'pk.halfPot': '½ Pot',
  'pk.pot': 'Pot',
  'pk.min': 'Min',
  'mr.drawStock': 'Draw',
  'mr.pickDiscard': 'Pick',
  'mr.discard': 'Discard',
  'mr.show': 'Show (see joker)',
  'mr.finish': 'Finish',
  'mr.tiplu': 'Joker: {card}',
  'mr.hiddenJoker': 'Joker hidden until you show',
  'mr.selectShow': 'Select 3 pure sequences or tunnelas',
  'mr.stock': 'Stock {n}',
  'mr.autoArrange': 'Auto-arrange',
  'results.title': 'Match results',
  'results.handResult': 'Hand result',
  'results.won': 'You won {n} coins!',
  'results.lost': 'You lost {n} coins',
  'results.place': '#{n}',
  'results.xp': '+{n} XP',
  'results.levelUp': 'Level up! You reached level {n}',
  'results.rating': 'Rating {r} ({d})',
  'results.playAgain': 'Play again',
  'results.lobby': 'Lobby',
  'results.bonusAd': 'Watch ad for +{n}',
  'rooms.create': 'Create private room',
  'rooms.game': 'Game',
  'rooms.table': 'Table',
  'rooms.password': 'Password (optional)',
  'rooms.code': 'Room code',
  'rooms.invite': 'Invite friends',
  'rooms.start': 'Start game',
  'rooms.waiting': 'Waiting for the host to start…',
  'rooms.members': 'Players ({n}/{max})',
  'rooms.lock': 'Lock room',
  'rooms.unlock': 'Unlock room',
  'rooms.cancel': 'Close room',
  'rooms.remove': 'Remove',
  'rooms.join': 'Join room',
  'rooms.enterCode': 'Enter room code',
  'rooms.shareText': 'Join my {game} table on Card Hub! Code {code}: {url}',
  'friends.title': 'Friends',
  'friends.search': 'Search players',
  'friends.add': 'Add',
  'friends.requests': 'Requests',
  'friends.accept': 'Accept',
  'friends.reject': 'Decline',
  'friends.recent': 'Recently played',
  'friends.empty': 'No friends yet. Search for players or invite your friends!',
  'friends.inviteLink': 'Invite with your link',
  'friends.status.idle': 'Online',
  'friends.status.in_game': 'In a game',
  'friends.status.offline': 'Offline',
  'friends.block': 'Block',
  'friends.unblock': 'Unblock',
  'friends.report': 'Report',
  'friends.remove': 'Remove friend',
  'friends.requestSent': 'Request sent',
  'profile.title': 'Profile',
  'profile.stats': 'Statistics',
  'profile.played': 'Played',
  'profile.won': 'Won',
  'profile.winRate': 'Win rate',
  'profile.rating': 'Rating',
  'profile.achievements': 'Achievements',
  'profile.history': 'Match history',
  'profile.wallet': 'Wallet history',
  'profile.referral': 'Invite & earn',
  'profile.editName': 'Change name',
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.theme.dark': 'Dark',
  'settings.theme.light': 'Light',
  'settings.theme.system': 'System',
  'settings.sound': 'Sound effects',
  'settings.music': 'Music',
  'settings.volume': 'Master volume',
  'settings.haptics': 'Haptic feedback',
  'settings.graphics': 'Graphics quality',
  'settings.reducedMotion': 'Reduce motion',
  'settings.highContrast': 'High contrast',
  'settings.fontSize': 'Text size',
  'settings.colorBlind': 'Four-colour deck (colour-blind friendly)',
  'settings.notifications': 'Notifications',
  'settings.privacy': 'Privacy',
  'settings.showOnline': 'Show when I am online',
  'settings.allowRequests': 'Allow friend requests',
  'settings.leaderboards': 'Show me on leaderboards',
  'settings.analytics': 'Share anonymous usage data',
  'settings.account': 'Account',
  'settings.export': 'Download my data',
  'settings.delete': 'Delete account',
  'settings.deleteConfirm': 'This permanently deletes your account. Type DELETE to confirm.',
  'settings.help': 'Help & FAQ',
  'settings.legal': 'Coins are virtual, have no cash value and cannot be withdrawn.',
  'notif.friendRequests': 'Friend requests',
  'notif.gameInvites': 'Game invitations',
  'notif.dailyReward': 'Daily reward',
  'notif.missions': 'Missions & achievements',
  'notif.tournaments': 'Tournaments',
  'notif.yourTurn': 'Your turn',
  'notif.promotions': 'Offers & events',
  'notif.title': 'Notifications',
  'notif.empty': "You're all caught up.",
  'notif.markAll': 'Mark all read',
  'daily.title': 'Daily rewards',
  'daily.day': 'Day {n}',
  'daily.claim': 'Claim reward',
  'daily.comeBack': 'Come back tomorrow',
  'missions.title': 'Missions',
  'missions.daily': 'Daily',
  'missions.weekly': 'Weekly',
  'missions.resets': 'Resets {time}',
  'store.title': 'Coin store',
  'store.buy': 'Buy',
  'store.disabled': 'Purchases are not available right now.',
  'store.note': 'Coins are for entertainment only and cannot be cashed out.',
  'store.freeCoins': 'Free coins',
  'ads.watch': 'Watch a short video',
  'ads.reward': 'Earn {n} coins',
  'ads.playing': 'Ad playing… {s}s',
  'ads.limit': 'Daily limit reached',
  'ads.credited': '+{n} coins added!',
  'lb.title': 'Leaderboards',
  'lb.daily': 'Today',
  'lb.weekly': 'Week',
  'lb.monthly': 'Month',
  'lb.allTime': 'All time',
  'lb.wins': 'Wins',
  'lb.xp': 'XP',
  'lb.games': 'Games',
  'lb.coins': 'Coins won',
  'lb.all': 'All games',
  'lb.you': 'You: #{rank}',
  'lb.empty': 'No scores yet for this period. Play a game to get on the board!',
  'tut.next': 'Next',
  'tut.practice': 'Practice game',
  'tut.replay': 'Replay tutorial',
  'help.title': 'Help & FAQ',
  'report.title': 'Report player',
  'report.reason': 'Reason',
  'report.details': 'Details (optional)',
  'report.submit': 'Submit report',
  'report.thanks': 'Thanks — our moderators will review it.',
  'settings.security': 'Security',
  'mfa.title': 'Two-factor authentication',
  'mfa.onBody': 'On — a code from your authenticator app is required to sign in.',
  'mfa.offBody': 'Protect your account with an authenticator app. Required for staff.',
  'mfa.setup': 'Set up',
  'mfa.scan': 'Scan with Google Authenticator, Microsoft Authenticator or 1Password, then enter the 6-digit code.',
  'mfa.enable': 'Enable',
  'mfa.disable': 'Disable',
  'mfa.enabled': 'Two-factor authentication enabled',
  'mfa.disabled': 'Two-factor authentication disabled',
  'mfa.code': 'Authenticator code',
  'mfa.loginHint': 'Two-factor authentication is on for this account.',
  'mfa.qr': 'Authenticator QR code',
  'replay.title': 'Replay',
  'replay.watch': 'Watch replay',
  'replay.controls': 'Replay controls',
  'replay.start': 'Back to start',
  'replay.prev': 'Previous step',
  'replay.next': 'Next step',
  'replay.play': 'Play',
  'replay.pause': 'Pause',
  'replay.position': 'Replay position',
  'replay.step': 'Step {n} of {total}',
  'replay.speed': 'Playback speed',
  'watch.title': 'Watch live',
  'watch.cta': 'Watch',
  'watch.banner': 'Spectating — cards stay hidden',
  'cosmetics.title': 'Card backs & tables',
  'cosmetics.cardBack': 'Card back',
  'cosmetics.felt': 'Table felt',
  'cosmetics.locked': 'unlocks at level {n}',
  'cosmetics.back.classic': 'Classic',
  'cosmetics.back.crimson': 'Crimson',
  'cosmetics.back.midnight': 'Midnight',
  'cosmetics.back.saffron': 'Saffron',
  'cosmetics.back.himalaya': 'Himalaya',
  'cosmetics.back.gold': 'Gold',
  'cosmetics.felt.emerald': 'Emerald',
  'cosmetics.felt.royal': 'Royal blue',
  'cosmetics.felt.maroon': 'Maroon',
  'cosmetics.felt.charcoal': 'Charcoal',
  'cosmetics.felt.teal': 'Teal',
  'theme.toLight': 'Switch to light mode',
  'theme.toDark': 'Switch to dark mode',
  'cb.yourCall': 'Your call',
  'cb.moreBids': 'Show 9 to 13',
  'sp.bid': 'Bid your tricks',
  'sp.yourBid': 'Your bid',
  'sp.bidValue': 'Bid {n}',
  'sp.bidNil': 'Bid Nil',
  'sp.nil': 'Nil',
  'sp.nilLong': 'Nil (win no tricks)',
  'sp.round': 'Round {n}',
  'sp.broken': 'Spades broken',
  'sp.partner': 'Partner',
  'sp.us': 'Us',
  'sp.them': 'Them',
  'sp.bags': '{n} bags',
  'sp.bagsWord': 'bags',
  'sp.roundScores': 'Round {n} scores',
  'sp.scoreHint': 'First to {target} wins; a team at {lose} loses. Every 10 bags costs 100 points.',
  'ta.bid': 'Bid your tricks',
  'ta.yourBid': 'Your bid',
  'ta.pass': 'Pass',
  'ta.bidTag': 'Bid {n}',
  'ta.trump': 'Trump',
  'ta.choosing': '{name} is choosing trump',
  'ta.passHint': 'Bid 7 or more, or pass',
  'ta.mustBid': 'Everyone passed — you must bid',
  'ta.chooseTrump': 'Choose trump',
  'ta.scoreHint': 'First to {target} wins. A made bid scores its tricks (13 scores 16); a missed bid loses the bid. Defenders score their tricks.',
  'cp.caller': 'Caller',
  'cp.scoreHint': 'First to {target} courts wins. A team that takes 7 or more of the 13 tricks wins the court; taking all 13 is worth 2. The caller names trump after seeing five cards and keeps the role while their team wins.',
  'hr.dir.left': 'the left',
  'hr.dir.right': 'the right',
  'hr.dir.across': 'the player across',
  'hr.dir.hold': 'nobody',
  'hr.passTitle': 'Pass 3 cards to {dir}',
  'hr.noPass': 'No passing this round',
  'hr.pickThree': '{n}/3 selected',
  'hr.passBtn': 'Pass cards',
  'hr.passed': 'Passed',
  'hz.pts': 'pts',
  'hz.hand': 'Hand {n}',
  'hz.handScores': 'Hand {n} scores',
  'hz.leadHint': 'Your lead — play any card',
  'hz.won': '{name} takes {n} points',
  'hz.scoreHint': 'Highest score wins. The match ends when a player reaches {target} with the top score, or after {max} hands. A trick scores its cards: A 11, 10 10, K 4, Q 3, J 2, and the last trick adds 10.',
  'hr.broken': 'Hearts broken',
  'hr.received': 'You received',
  'hr.moon': '{name} shot the moon!',
  'hr.scoreHint': 'Lowest score wins. The game ends when a player reaches {target}. Each heart is 1 point and the Queen of Spades is 13; taking all 26 shoots the moon.',
  'fh.bid': 'Place your bid',
  'fh.yourBid': 'Your bid',
  'fh.contract': 'Contract',
  'fh.choosingDiscard': '{name} is choosing discards',
  'fh.discardTitle': 'Discard 3 cards',
  'fh.discardBtn': 'Discard',
  'fh.nameSuit': 'Name the suit for the joker',
  'fh.follow': 'Follow {suit}',
  'fh.made': 'Made',
  'fh.failed': 'Failed',
  'fh.scoreHint': 'First team to {target} wins; a team at -{target} loses. A made bid scores its value (10 tricks is worth at least 250), a missed bid loses it, and the other team scores 10 per trick.',
  'ju.bid': 'Bid your tricks',
  'ju.yourBid': 'Your bid',
  'ju.bidValue': 'Bid {n}',
  'ju.round': 'Round {n}/{total}',
  'ju.card': '1 card',
  'ju.cards': '{n} cards',
  'ju.trump': 'Trump',
  'ju.trumpCard': 'Trump card',
  'ju.hook': "As dealer you can't bid {n} — the bids may not add up to the tricks.",
  'ju.scoreHint': 'Win exactly the tricks you bid to score 10 plus your bid; miss and you lose the size of the miss. The hand size changes every round and the highest total wins.',
  'ru.deal': 'Deal {n}/{total}',
  'ru.wild': 'Wild: {rank}',
  'ru.cutJoker': 'Cut joker',
  'ru.points': 'Points: {n}',
  'ru.dropped': 'Dropped',
  'ru.drop': 'Drop',
  'ru.dropTitle': 'Drop this deal?',
  'ru.dropBody': 'You sit out the deal and take {n} points.',
  'ru.declare': 'Declare',
  'ru.declareTitle': 'Declare your hand',
  'ru.declareBody': 'Discard {card} and show these groups.',
  'ru.notReady': 'Not a winning hand yet: you need a pure sequence, a second sequence, and every other card in a sequence or set.',
  'ru.winner': '{name} declared!',
  'ru.lastPlayer': '{name} wins — everyone else dropped',
  'ru.stockOut': 'The stock ran out — no winner',
  'ru.scoreHint': 'Lowest total wins. The winner of a deal scores 0; everyone else scores their ungrouped cards (A/K/Q/J/10 = 10, wilds 0), at most {max}. Dropping costs 20 before your first draw and 40 later.',
  'eu.bid': 'Your call',
  'eu.call': 'Name trump',
  'eu.orderUp': 'Order up',
  'eu.orderedUp': 'Ordered up',
  'eu.called': 'Called',
  'eu.alone': 'Go alone',
  'eu.callSuit': 'Call {suit}',
  'eu.round1Hint': 'Order up to make {suit} trump, or pass',
  'eu.round2Hint': 'Name a different suit, or pass',
  'eu.mustCall': 'Everyone passed — you must name trump',
  'eu.turnedUp': 'Turned up',
  'eu.turnedDown': 'Turned down · not {suit}',
  'eu.discardTitle': 'Discard a card',
  'eu.pickUp': 'You picked up {card}',
  'eu.discard': 'Choose a card',
  'eu.discardCard': 'Discard {card}',
  'eu.waitingDiscard': '{name} is discarding',
  'eu.maker': 'Maker',
  'eu.sitting': 'Sitting out',
  'eu.euchred': 'Euchred',
  'eu.scoreHint': 'First team to {target} wins. Makers who take 3 or 4 tricks score 1, all 5 score 2 (4 if alone); makers who take fewer are euchred and the other team scores 2.',
  'gr.hand': 'Hand {n}',
  'gr.goal': 'to {n}',
  'gr.wins': '{n} won',
  'gr.upcard': 'Upcard',
  'gr.take': 'Take upcard',
  'gr.pass': 'Pass',
  'gr.stockOnly': 'Both passed — draw from the stock',
  'gr.knock': 'Knock',
  'gr.gin': 'Gin!',
  'gr.deadwood': 'Deadwood: {n}',
  'gr.deadwoodLabel': 'Deadwood',
  'gr.knocked': '{name} knocked and won the hand',
  'gr.ginned': '{name} went gin!',
  'gr.undercut': '{name} undercut the knock!',
  'gr.undercutShort': 'Undercut',
  'gr.drawHand': 'Hand drawn — nobody scores',
  'gr.scoreHint': 'First to {target} wins. Knock with 10 or less deadwood: score the difference. Gin scores 25 plus their deadwood; an undercut scores the difference plus 25. The winner adds 100, and each hand won adds 25.',
  'tn.bid': 'Bid your points',
  'tn.passHint': 'Bid {n} or more, or pass',
  'tn.yourTrump': 'Your trump',
  'tn.trumpHidden': 'Trump hidden',
  'tn.trumpSecret': 'Kept secret until someone asks',
  'tn.reveal': 'Ask for trump',
  'tn.revealHint': 'Out of the led suit — ask to see the trump',
  'tn.asked': 'Asked',
  'tn.scoreHint': 'First team to +{target} wins; −{target} loses. The bidders need card points (J 3, 9 2, A 1, 10 1 — 28 in all) to reach their bid: +1 if they do, −1 if not. The trump stays hidden until a player who cannot follow suit asks for it.',
  'ce.goal': 'to {n}',
  'ce.suit': 'Suit',
  'ce.lacks': 'Had to draw — has none of these suits',
  'ce.nameSuit': 'Name the suit',
  'ce.draw': 'Draw ({n}/{max})',
  'ce.out': '{name} went out!',
  'ce.blocked': 'Blocked — {name} has the lowest hand',
  'ce.blockedNone': 'Blocked — a tie, nobody scores',
  'ce.scoreHint': 'First to {target} wins. Going out scores the cards left in the other hands (eight 50, K Q J 10 ten each, ace 1, others face value). A blocked round goes to the lowest hand for the difference.',
  'cg.you': 'You',
  'cg.dealer': 'Dealer',
  'cg.starter': 'Starter',
  'cg.crib': "{name}'s crib",
  'cg.counting': 'Counting…',
  'cg.nineteen': 'Nineteen — no points',
  'cg.count': 'Count {n}',
  'cg.toCrib': 'Send to crib ({n}/2)',
  'cg.playHint': 'Play a card — the count may not pass 31',
  'cg.r.fifteen': 'fifteen',
  'cg.r.thirtyone': 'thirty-one',
  'cg.r.pair': 'pair',
  'cg.r.pairRoyal': 'pair royal',
  'cg.r.doubleRoyal': 'double pair royal',
  'cg.r.run': 'run of {n}',
  'cg.r.lastCard': 'last card',
  'cg.r.heels': 'his heels',
  'cg.r.pone': 'hand',
  'cg.r.dealer': 'hand',
  'cg.r.crib': 'crib',
  'cg.i.fifteen': 'Fifteens',
  'cg.i.pair': 'Pairs',
  'cg.i.run': 'Runs',
  'cg.i.flush': 'Flush',
  'cg.i.nobs': 'Nobs',
  'cg.scoreHint': 'First to {target} wins. Points are pegged as they are earned: fifteens and pairs while playing the count, then hands and the dealer\'s crib. Fifteens score 2, pairs 2, runs their length, a flush 4 or 5, and the jack of the starter\'s suit (nobs) 1.',
  'bj.dealer': 'Dealer',
  'bj.shoe': 'Shoe {n}',
  'bj.hand': 'Hand',
  'bj.bust': 'Bust',
  'bj.r.BLACKJACK': 'Blackjack!',
  'bj.r.WIN': 'Win',
  'bj.r.PUSH': 'Push',
  'bj.r.LOSE': 'Lose',
  'bj.r.BUST': 'Bust',
  'bj.sitting': 'Sitting out',
  'bj.betting': 'Placing bets…',
  'bj.placeBet': 'Place your bet',
  'bj.limits': 'Min {min} · max {max}',
  'bj.sitOut': 'Sit out',
  'bj.bet': 'Bet {n}',
  'bj.actions': 'Your move',
  'bj.stand': 'Stand',
  'bj.hit': 'Hit',
  'bj.double': 'Double',
  'bj.split': 'Split',
  'bj.waiting': 'Waiting for players…',
  'bj.handOver': 'Hand over',
  'bj.dealerPlays': 'Dealer plays…',
  'bj.wait': 'Waiting for the other players…',
  'bh.cards': '{n} cards',
  'bh.out': 'Out · {n}',
  'bh.bhabhiTag': 'Bhabhi',
  'bh.voids': 'Could not follow — has none of these suits',
  'bh.round': 'Round {n}',
  'bh.discarded': 'Discarded {n}',
  'bh.lead': 'Lead',
  'bh.firstHint': 'You hold the ace of spades — lead it',
  'bh.leadHint': 'Lead any card',
  'bh.dumpHint': 'No {suit}? Play any card — it goes to whoever picks up the pile',
  'bh.followHint': 'Follow suit: {suit}',
  'bh.pickup': '{name} picks up {n} cards',
  'bh.discard': 'Round cleared — {name} leads next',
  'bh.thulla': 'Thulla!',
  'bh.noBhabhi': 'Everyone got out — no Bhabhi!',
  'bh.isBhabhi': '{name} is the Bhabhi!',
  'bh.player': 'Player',
  'bh.cardsLeft': 'Cards left',
  'bh.outShort': 'Out',
  'bh.scoreHint': 'Get rid of all your cards. Follow the led suit; if everyone does, the round is discarded and the highest card leads. If you cannot follow, play any card — the highest card of the led suit must pick up the whole pile. The last player holding cards is the Bhabhi.',
  'pr.cards': '{n} cards',
  'pr.out': 'Out · {n}',
  'pr.president': 'President',
  'pr.vice': 'Vice President',
  'pr.neutral': 'Neutral',
  'pr.scum': 'Scum',
  'pr.leadHint': 'Your lead — play a card, or a set of equal ranks',
  'pr.followHint': 'Beat it with {n} higher — or pass',
  'pr.passed': 'Passed',
  'pr.play': 'Play',
  'pr.pass': 'Pass',
  'pr.cleared': 'Pile cleared',
  'pr.clearedTwo': '{name} played a two — pile cleared',
  'pr.clearedPasses': 'Everyone passed — {name} leads',
  'pr.pile': 'Pile {n}',
  'pr.player': 'Player',
  'pr.cardsLeft': 'Cards left',
  'pr.outShort': 'Out',
  'pr.scoreHint': 'Play every card first. Beat the pile with the same number of higher cards, or pass; twos are highest and clear the pile. The last player holding cards is the Scum.',
  'gf.cards': '{n} cards',
  'gf.books': '{n} books',
  'gf.booksOf': 'Books laid down',
  'gf.stock': 'Stock: {n}',
  'gf.empty': 'No asks yet',
  'gf.pickHint': 'Tap a card to choose the rank you want, then pick a player',
  'gf.askHint': 'Ask for {rank}s — pick a player',
  'gf.ask': 'Ask {name}',
  'gf.logHit': '{a} took {n} × {rank} from {b}',
  'gf.logMiss': '{a} asked {b} for {rank} — Go Fish!',
  'gf.logLuck': '{a} fished a {rank} — goes again!',
  'gf.logNoLuck': '{a} asked {b} for {rank} — no luck',
  'gf.wins': '{name} wins with {n} books',
  'gf.player': 'Player',
  'gf.booksCol': 'Books',
  'gf.cardsCol': 'Cards',
  'gf.scoreHint': 'Ask a player for a rank you hold. A hit lets you ask again; a miss means Go Fish. Four of a rank is a book — most books wins.',
  'wr.cards': '{n} cards',
  'wr.rounds': '{n} won',
  'wr.round': 'Round {n} of {max}',
  'wr.table': 'Table',
  'wr.laid': 'Face down: you {a} · them {b}',
  'wr.raised': '{name} raised',
  'wr.stayed': 'No raise',
  'wr.flip': 'Flip',
  'wr.stay': 'Stay',
  'wr.raise': 'Raise +1 card',
  'wr.player': 'Player',
  'wr.cardsCol': 'Cards',
  'wr.roundsCol': 'Rounds won',
  'wr.scoreHint': 'Flip a card each round; the higher card wins both. A tie is war: stay or raise, lay cards face down and flip again. After {max} rounds the player with more cards wins.',
  'wr.over': '{name} wins the match',
  'wr.war': 'War! {n} cards on the table',
  'wr.roundWon': '{name} takes {n} cards',
  'wr.yourFlip': 'Your flip',
  'wr.waiting': 'Waiting for {name}',
  'pr.empty': 'Lead any card or set',
  'pr.isScum': '{name} is the Scum',
  'pr.selectHint': 'Tap cards of the same rank, then Play',
  'pn.noMeld': 'No meld',
  'pn.meld': 'Meld',
  'pn.noTrick': 'no trick',
  'pn.passing': '{name} is passing cards',
  'pn.passTitle': 'Pass cards',
  'pn.passToDeclarer': 'Pass your 3 best cards to the declarer',
  'pn.passToPartner': 'Pass 3 cards back to your partner',
  'pn.pick': '{n}/3 chosen',
  'pn.passBtn': 'Pass 3 cards',
  'pn.bid': 'Bid your points',
  'pn.passHint': 'Bid {n} or more, or pass',
  'pn.scoreHint': 'First team to {target} wins. A team scores its meld plus counters (A, 10, K and the last trick, 25 in all) but only if it takes a trick; the bidding team that falls short loses its bid. You must follow suit and beat the winning card when you can; with no card of the suit you must trump.',
  'ab.andar': 'Andar',
  'ab.bahar': 'Bahar',
  'ab.joker': 'Joker',
  'ab.pays': 'Pays {n}:1',
  'ab.noCards': 'Waiting for the deal',
  'ab.noBets': 'No bets',
  'ab.side': 'Choose a side',
  'ab.bet': 'Bet {n} on {side}',
  'ab.wins': '{side} wins!',
  'ab.youWon': 'You won {n}',
  'ab.youLost': 'You lost {n}',
  'ab.dealing': 'Dealing…',
  'ab.yourBet': 'Your bet: {n} on {side}',
  'br.declarer': 'Declarer',
  'br.dummy': 'Dummy',
  'br.vul': 'Vulnerable',
  'br.deal': 'Deal {n}/{total}',
  'br.by': 'by {name}',
  'br.auction': 'Auction',
  'br.dealDone': 'Deal {n} complete',
  'br.passedOut': 'Passed out — no score',
  'br.passedOutShort': 'Passed out',
  'br.dummyHand': 'Dummy ({seat})',
  'br.playFromDummy': 'tap a card to play it for the dummy',
  'br.contract': 'Contract',
  'br.yourCall': 'Your call',
  'br.last': 'Last bid',
  'br.noBids': 'No bids yet',
  'br.level': 'Level',
  'br.strain': 'Suit',
  'br.pass': 'Pass',
  'br.scoreHint': 'Chicago match of {deals} deals: the higher total wins. Vulnerability: none, then the dealer\'s side twice, then both. Making a contract scores trick points plus bonuses (game 300/500, slams, doubles); failing it scores the defenders 50/100 a trick. The declarer plays the dummy\'s cards.',
  'sv.board': 'Cards on the table',
  'sv.passes': 'Times passed',
  'sv.passTag': 'Passed {n}',
  'sv.over': 'Game over',
  'sv.startHint': 'You hold the 7♦ — play it to start',
  'sv.playHint': 'Play a highlighted card',
  'sv.noPlay': 'Nothing to play — pass',
  'sv.scoreHint': 'Be the first to play out your hand. Start each suit with its 7, then add the card just above or below the run. Ace is low. If you cannot play you pass. The last player holding cards loses.',
  'sc.deck': 'Deck {n}',
  'sc.table': 'Cards on the table',
  'sc.empty': 'Table is clear',
  'sc.captured': 'took {n} with {card}',
  'sc.trailed': 'put down {card}',
  'sc.scopa': 'Scopa!',
  'sc.choose': 'Your move',
  'sc.pickCard': 'Pick a card to play',
  'sc.trail': 'Put down {card}',
  'sc.capture': 'Take',
  'sc.dealResult': 'Deal {n} scored',
  'sc.cards': 'Cards',
  'sc.diamonds': 'Diamonds',
  'sc.settebello': '7♦',
  'sc.primiera': 'Primiera',
  'sc.scopas': 'Scopas',
  'sc.total': 'Points',
  'sc.scoreHint': 'First team to {target} wins. Play a card to take a table card of the same value, or cards that add up to it (ace 1, jack 8, queen 9, king 10); you must capture when you can. A scopa (clearing the table) scores 1. Each deal also scores 1 for most cards, most diamonds, the 7♦ and the best primiera.',
  'se.deck': 'Deck {n}',
  'se.floor': 'Cards on the floor',
  'se.empty': 'Floor is clear',
  'se.took': 'took {n} with {card}',
  'se.trailed': 'put down {card}',
  'se.built': 'built a house of {v} with {card}',
  'se.seep': 'Seep!',
  'se.choose': 'Your move',
  'se.pickCard': 'Pick a card to play',
  'se.trail': 'Put down {card}',
  'se.take': 'Take',
  'se.build': 'Build {v}',
  'se.raise': 'Raise house to {v}',
  'se.house': 'House of {v}',
  'se.dealResult': 'Deal {n} scored',
  'se.cards': 'Cards',
  'se.cardPoints': 'Card points',
  'se.seeps': 'Seeps',
  'se.total': 'Points',
  'se.scoreHint': 'First team to {target} wins. Play a card to take a floor card of the same value, or cards that add up to it (ace 1, jack 11, queen 12, king 13), or build a house of 9–13 you can later capture. Spades score their face value, other aces 1 and the 10♦ 6; a seep (clearing the floor) is worth 50.',
  'bc.player': 'Player',
  'bc.banker': 'Banker',
  'bc.tie': 'Tie',
  'bc.pays': 'Pays {n}:1',
  'bc.tieWins': 'Tie — the hands are level',
  'bc.natural': 'Natural',
  'bc.push': 'Bet returned',
  'bc.bets': 'Bets on the table',
  'dt.dragon': 'Dragon',
  'dt.tiger': 'Tiger',
  'dt.tie': 'Tie',
  'dt.tieWins': 'Tie — both cards are level',
  'tcp.ante': 'Ante',
  'tcp.pairPlus': 'Pair Plus',
  'tcp.dealer': 'Dealer',
  'tcp.yourHand': 'Your hand',
  'tcp.bet': 'Ante {n}',
  'tcp.betPP': 'Ante {n} + Pair Plus {pp}',
  'tcp.play': 'Play {n}',
  'tcp.fold': 'Fold',
  'tcp.decide': 'Play or fold?',
  'tcp.noQualify': 'Dealer does not qualify',
  'tcp.dealerQualifies': 'Dealer qualifies',
  'tcp.win': 'Win',
  'tcp.lose': 'Lose',
  'tcp.push': 'Push',
  'tcp.folded': 'Folded',
  'tcp.bonus': 'Bonus {n}',
  'tcp.ppWin': 'Pair Plus {n}',
  'tcp.pairPlusBet': 'Pair Plus side bet',
  'tcp.antePlay': 'Ante and play',
  'tcp.youBet': 'Ante {n}',
  'tcp.cat.HIGH_CARD': 'High card',
  'tcp.cat.PAIR': 'Pair',
  'tcp.cat.FLUSH': 'Flush',
  'tcp.cat.STRAIGHT': 'Straight',
  'tcp.cat.THREE_OF_A_KIND': 'Three of a kind',
  'tcp.cat.STRAIGHT_FLUSH': 'Straight flush',
  'tcp.wait': 'Waiting for the other players…',
  'tcp.revealing': 'Dealer turns the cards…',
  'pgw.dealer': 'Dealer',
  'pgw.yourHand': 'Your seven cards',
  'pgw.pickLow': 'Tap two cards for the low hand',
  'pgw.high': 'High hand (5 cards)',
  'pgw.low': 'Low hand (2 cards)',
  'pgw.foul': 'The five-card hand must beat the two-card hand',
  'pgw.houseWay': 'House way',
  'pgw.setHands': 'Set hands',
  'pgw.bet': 'Bet {n}',
  'pgw.youBet': 'Bet {n}',
  'pgw.isSet': 'Hands set',
  'pgw.wait': 'Waiting for the other players…',
  'pgw.revealing': 'Dealer shows the hands…',
  'pgw.commission': 'Commission {n}',
  'pgw.highWon': 'High hand won',
  'pgw.highLost': 'High hand lost',
  'pgw.lowWon': 'Low hand won',
  'pgw.lowLost': 'Low hand lost',
  'pgw.cat.HIGH_CARD': 'High card',
  'pgw.cat.PAIR': 'Pair',
  'pgw.cat.TWO_PAIR': 'Two pair',
  'pgw.cat.THREE_OF_A_KIND': 'Three of a kind',
  'pgw.cat.STRAIGHT': 'Straight',
  'pgw.cat.FLUSH': 'Flush',
  'pgw.cat.FULL_HOUSE': 'Full house',
  'pgw.cat.FOUR_OF_A_KIND': 'Four of a kind',
  'pgw.cat.STRAIGHT_FLUSH': 'Straight flush',
  'pgw.cat.ROYAL_FLUSH': 'Royal flush',
  'pgw.cat.FIVE_ACES': 'Five aces',
  'cw.dealer': 'Dealer',
  'cw.bet': 'Bet {n}',
  'cw.tieBet': 'Tie bet',
  'cw.addTieBet': 'Add a Tie bet of {n} (pays {p}:1)',
  'cw.yourBet': 'Your bet: {n}',
  'cw.tied': 'Tie! Go to war or surrender?',
  'cw.war': 'Go to war (+{n})',
  'cw.surrender': 'Surrender (get {n} back)',
  'cw.warOn': 'War! Three cards burned',
  'cw.waitTie': 'Waiting for {name} to decide…',
  'cw.outWin': 'You won {n}',
  'cw.outWar': 'War won: +{n}',
  'cw.outWarLost': 'War lost: −{n}',
  'cw.outSurrender': 'Surrendered: −{n}',
  'cw.warCard': 'War card',
  'cw.bets': 'Players',
  'rdg.spreadTitle': 'The spread',
  'rdg.thirdCard': 'Third card',
  'rdg.spread': 'Spread {n} · wins pay {p}:1',
  'rdg.consecutive': 'Touching ranks — push',
  'rdg.pair': 'Equal ranks — a third card decides',
  'rdg.ante': 'Place your ante',
  'rdg.betAnte': 'Ante {n}',
  'rdg.yourBet': 'Your bet: {n}',
  'rdg.bets': 'Players',
  'rdg.decide': 'Raise or stay?',
  'rdg.decideHint': 'Spread {n} · pays {p}:1',
  'rdg.raiseBy': 'Raise by',
  'rdg.raise': 'Raise +{n}',
  'rdg.stay': 'Stay',
  'rdg.raised': 'Raised',
  'rdg.stayed': 'Stayed',
  'rdg.waitDecide': 'Waiting for {name} to decide…',
  'rdg.outWin': 'You won {n}',
  'rdg.outTrips': 'Three of a kind! +{n}',
  'rdg.outLose': 'You lost {n}',
  'rdg.outPush': 'Push — ante returned',
  'bl.claim': 'Claim',
  'bl.pile': 'Pile {n}',
  'bl.empty': 'Empty',
  'bl.claimed': '{name} put down {n} × {rank}',
  'bl.honest': 'Honest! {name} takes the pile ({n})',
  'bl.caught': 'Caught bluffing! {name} takes the pile ({n})',
  'bl.winner': 'Winner',
  'bl.wins': '{name} wins!',
  'bl.call': 'Call bluff!',
  'bl.accept': 'Accept — {name} goes out',
  'bl.pick': 'Pick cards to claim {rank}',
  'bl.play': 'Put down {n} as {rank}',
  'bl.scoreHint': 'First to get rid of every card wins; the rest are ranked by cards left. Put 1–4 cards face down and claim the required rank — you may be lying. The next player can call your bluff: if you lied you take the whole pile, otherwise they do. Your last cards must survive a challenge to win.',
  'pn.m.run': 'Run',
  'pn.m.doubleRun': 'Double run',
  'pn.m.royal': 'Royal marriage',
  'pn.m.marriage': 'Marriage',
  'pn.m.dix': 'Dix',
  'pn.m.pinochle': 'Pinochle',
  'pn.m.doublePinochle': 'Double pinochle',
  'pn.m.aces': 'Aces around',
  'pn.m.kings': 'Kings around',
  'pn.m.queens': 'Queens around',
  'pn.m.jacks': 'Jacks around',
  'pn.m.doubleAces': 'Double aces',
  'pn.m.doubleKings': 'Double kings',
  'pn.m.doubleQueens': 'Double queens',
  'pn.m.doubleJacks': 'Double jacks',
} as const;

export type MessageKey = keyof typeof en;
